import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Profilecard from './components/profilecard';
import Sidebar from './components/sidebar';
import MobileSidebar from './components/mobilesidebar';
import Home from './pages/home';
import About from './pages/about';
import Experties from './pages/experties';
import Contact from './pages/contact';
import Blogs from './pages/blogs';
import Projects from './pages/projects';
import Slider from './components/slider';
import tailwind from './assets/images/skills/tailwind.png';
import html from './assets/images/skills/html.png';
import css from './assets/images/skills/css.png';
import wp from './assets/images/skills/wp.png';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const project_images = [tailwind, html, wp, css];
  const notifyError = (message) => {
    toast.warning(message, {
      // position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  };

  return (
    <Router>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        // theme="colored"
      />
      <div className="flex gap-5 md:px-12 py-[2vh] md:w-[100vw] flex-col md:flex-row ">
        {/* Render Profilecard component */}
        <div class="flex flex-col rounded-xl bg-secondary bg-clip-border md:w-[22%] md:h-[95vh] ">
          <Profilecard />
        </div>

        {/* Render different pages based on route */}
        <div class="relative flex flex-col rounded-xl bg-secondary md:h-[95vh] md:w-[78%] pl-4 md:pl-6 pr-2 pb-2">
          {/* <div class="relative flex flex-col rounded-xl bg-secondary md:h-[95vh] md:w-[100%] pl-6 pr-2 pb-2"> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/expertise" element={<Experties />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route
              path="/projects"
              element={<Projects notifyError={notifyError} />}
            />
            <Route
              path="/slider"
              element={<Slider images={project_images} />}
            />
          </Routes>
        </div>

        {/* Render Sidebar component */}
        {/* <div class="hidden md:flex flex-col gap-3 p-4 rounded-xl bg-secondary h-fit md:w-[8%]">
          <Sidebar />
        </div> */}

        {/* Render MobileSidebar component */}
        <MobileSidebar />
      </div>
    </Router>
  );
}

export default App;
